import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: 'ellipsis'
})
export class EllipsisPipe implements PipeTransform {
    transform(value: string, max: number = 13) {
        return (value && (value.length > max)) ? `${value.substr(0, max)}...` : value;
    }
}